import i18n from "i18next";
import { useEffect } from "react";

import LoginState from "@krea/common/shared-components/login/LoginState";
import Preloader from "@krea/common/shared-components/preloader";
import { isMobile } from "@krea/common/utils";
import Button from "@krea/common/shared-components/button";
import { useModalStore } from "@krea/common/store/modal/hooks";
import { useShallow } from "zustand/react/shallow";
import { useLoanApplicationFormStore } from "@krea/common/store/loan-application-form/hooks";

import { useInitiateLoanApplication } from "store/loan-application-form/hooks";

const BankIDFlow = (isPending) => {
  const {
    isPending: isP,
    isUserCancel,
    isError,
    cancelApplicationViaBankID,
  } = useInitiateLoanApplication();

  useEffect(() => {
    const windowEvent = isMobile() ? "pagehide" : "beforeunload";

    function handleWindowClose() {
      if (isPending) {
        cancelApplicationViaBankID();
      }
    }

    window.addEventListener(windowEvent, handleWindowClose);

    return () => window.removeEventListener(windowEvent, handleWindowClose);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { openModal, closeModal } = useModalStore(
    useShallow(({ openModal, closeModal }) => ({
      openModal,
      closeModal,
    })),
  );

  const { errorCode } = useLoanApplicationFormStore((state) => ({
    errorCode: state.formErrors.errorCode,
  }));

  if (isUserCancel) {
    return (
      <LoginState className="mt-2">
        {i18n.t("bankIDFlow.loginCancelled")}
      </LoginState>
    );
  } else if (isError) {
    if (errorCode === 1007)
      return (
        <>
          <LoginState className="mt-2" error>
            <div>
              <p>
                {i18n.t(
                  "remoteIdentification.fraudClientErrorPage.description",
                )}
              </p>
              <span>
                {i18n.t(
                  "remoteIdentification.fraudClientErrorPage.descriptionNewLine",
                )}
              </span>
            </div>
          </LoginState>
          <div className="tw-mt-4 tw-flex tw-justify-center">
            <Button
              onClick={() => {
                openModal({
                  modal: null,
                  closeOnBackgroundClick: false,
                  onCloseSideEffects: null,
                  isSupportTabOpen: true,
                });
              }}
            >
              {i18n.t(
                "commons.contactCustomerServiceDialog.contactCustomerService",
              )}
            </Button>
          </div>
        </>
      );
    return (
      <>
        <LoginState className="mt-2" error>
          {i18n.t("remoteIdentification.genericErrorPage.description")}
        </LoginState>
        <div className="tw-mt-4 tw-flex tw-justify-center">
          <Button
            onClick={() => {
              openModal({
                modal: null,
                closeOnBackgroundClick: false,
                onCloseSideEffects: null,
                isSupportTabOpen: true,
              });
            }}
          >
            {i18n.t(
              "commons.contactCustomerServiceDialog.contactCustomerService",
            )}
          </Button>
        </div>
      </>
    );
  }

  return (
    <div className="d-flex flex-column align-items-center w-100">
      <Preloader size="xxl" className="text-primary" />
    </div>
  );
};

export default BankIDFlow;
